import React from 'react'
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from '@material-ui/core'

export default function WYesNoField({data, onChange}) {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{data.name}</FormLabel>
      <RadioGroup
        row
        aria-label="gender"
        name="gender1"
        value={data.value}
        onChange={e => {
          onChange(e, 'value', data)
        }}
      >
        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="no" control={<Radio />} label="No" />
      </RadioGroup>
      <FormHelperText>{!data.is_required ? 'optional' : ''}</FormHelperText>
    </FormControl>
  )
}
